"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _RadialData2 = _interopRequireDefault(require("./RadialData"));

var hundredThousand = 100000;
var oneKb = 1000;
var oneMb = 1000000;
var threeMb = 3000000;
var fiveMb = 5000000;
var tenMb = 10000000;

var PageSizeRadialData =
/*#__PURE__*/
function (_RadialData) {
  (0, _inherits2.default)(PageSizeRadialData, _RadialData);

  function PageSizeRadialData() {
    (0, _classCallCheck2.default)(this, PageSizeRadialData);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PageSizeRadialData).apply(this, arguments));
  }

  (0, _createClass2.default)(PageSizeRadialData, [{
    key: "init",
    value: function init(grade) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(PageSizeRadialData.prototype), "init", this).call(this, grade);
      this.displayRecommendationValue = '< 3';
      this.displayRecommendationValueUnit = _I18n.default.text('results.data.mb');
    }
  }, {
    key: "setGradeType",
    value: function setGradeType(grade) {
      this.gradeType = this.getGoodOkBadGradeType(grade, threeMb, fiveMb);
    }
  }, {
    key: "setScore",
    value: function setScore(grade) {
      this.score = Math.round(Math.min(grade, tenMb) / hundredThousand);
    }
    /**
     * Sets the displayValue and displayValueUnit.
     *
     * E.g.
     *
     *   grade = 2000000
     *     displayValue = 2
     *     displayValueUnit = Mb
     *
     */

  }, {
    key: "setDisplayValue",
    value: function setDisplayValue(grade) {
      var displayValue;
      var displayValueUnit;

      if (grade >= oneMb) {
        displayValue = parseFloat((grade / oneMb).toFixed(1));
        displayValueUnit = _I18n.default.text('results.data.mb');
      } else if (grade >= oneKb) {
        displayValue = Math.round(grade / oneKb);
        displayValueUnit = _I18n.default.text('results.data.kb');
      } else {
        displayValue = grade;
        displayValueUnit = _I18n.default.text('results.data.b');
      }

      this.displayValue = displayValue;
      this.displayValueUnit = displayValueUnit;
    }
  }]);
  return PageSizeRadialData;
}(_RadialData2.default);

var _default = PageSizeRadialData;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/components/PageSizeRadialData.js
// module id = 270
// module chunks = 0